// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressModalController from "./address_modal_controller"
application.register("address-modal", AddressModalController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import CardBuilderController from "./card_builder_controller"
application.register("card-builder", CardBuilderController)

import CardPreviewController from "./card_preview_controller"
application.register("card-preview", CardPreviewController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import ContactImportController from "./contact_import_controller"
application.register("contact-import", ContactImportController)

import ContactSelectorController from "./contact_selector_controller"
application.register("contact-selector", ContactSelectorController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DeliveryMethodController from "./delivery_method_controller"
application.register("delivery-method", DeliveryMethodController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import DownloadController from "./download_controller"
application.register("download", DownloadController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EventDateController from "./event_date_controller"
application.register("event-date", EventDateController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FormLoadingController from "./form_loading_controller"
application.register("form-loading", FormLoadingController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import ImportProgressController from "./import_progress_controller"
application.register("import-progress", ImportProgressController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import RecipientSelectorController from "./recipient_selector_controller"
application.register("recipient-selector", RecipientSelectorController)

import RsvpController from "./rsvp_controller"
application.register("rsvp", RsvpController)

import RsvpSubscriptionController from "./rsvp_subscription_controller"
application.register("rsvp-subscription", RsvpSubscriptionController)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import SelectNavigateController from "./select_navigate_controller"
application.register("select-navigate", SelectNavigateController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TemplateEditorController from "./template_editor_controller"
application.register("template-editor", TemplateEditorController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import UrlScraperController from "./url_scraper_controller"
application.register("url-scraper", UrlScraperController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
